/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ApiResponseOfPlatformGroupResponse } from '../model';
// @ts-ignore
import { ApiResponseOfPlatformGroupResponseArray } from '../model';
// @ts-ignore
import { PlatformGroupBody } from '../model';
/**
 * PlatformGroupsApi - axios parameter creator
 * @export
 */
export const PlatformGroupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new platform group
         * @param {PlatformGroupBody} platformGroupBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (platformGroupBody: PlatformGroupBody, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformGroupBody' is not null or undefined
            assertParamExists('create', 'platformGroupBody', platformGroupBody)
            const localVarPath = `/api/v1/platformGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(platformGroupBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all platform groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/platformGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get platform group by ID
         * @param {string} platformGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (platformGroupId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformGroupId' is not null or undefined
            assertParamExists('getById', 'platformGroupId', platformGroupId)
            const localVarPath = `/api/v1/platformGroups/{platformGroupId}`
                .replace(`{${"platformGroupId"}}`, encodeURIComponent(String(platformGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete platform group by ID
         * @param {string} platformGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (platformGroupId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformGroupId' is not null or undefined
            assertParamExists('remove', 'platformGroupId', platformGroupId)
            const localVarPath = `/api/v1/platformGroups/{platformGroupId}`
                .replace(`{${"platformGroupId"}}`, encodeURIComponent(String(platformGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update platform group by ID
         * @param {string} platformGroupId 
         * @param {PlatformGroupBody} platformGroupBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (platformGroupId: string, platformGroupBody: PlatformGroupBody, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformGroupId' is not null or undefined
            assertParamExists('update', 'platformGroupId', platformGroupId)
            // verify required parameter 'platformGroupBody' is not null or undefined
            assertParamExists('update', 'platformGroupBody', platformGroupBody)
            const localVarPath = `/api/v1/platformGroups/{platformGroupId}`
                .replace(`{${"platformGroupId"}}`, encodeURIComponent(String(platformGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(platformGroupBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlatformGroupsApi - functional programming interface
 * @export
 */
export const PlatformGroupsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlatformGroupsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new platform group
         * @param {PlatformGroupBody} platformGroupBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(platformGroupBody: PlatformGroupBody, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfPlatformGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(platformGroupBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List all platform groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfPlatformGroupResponseArray>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get platform group by ID
         * @param {string} platformGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(platformGroupId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfPlatformGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(platformGroupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete platform group by ID
         * @param {string} platformGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(platformGroupId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(platformGroupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update platform group by ID
         * @param {string} platformGroupId 
         * @param {PlatformGroupBody} platformGroupBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(platformGroupId: string, platformGroupBody: PlatformGroupBody, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfPlatformGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(platformGroupId, platformGroupBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PlatformGroupsApi - factory interface
 * @export
 */
export const PlatformGroupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlatformGroupsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new platform group
         * @param {PlatformGroupBody} platformGroupBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(platformGroupBody: PlatformGroupBody, options?: any): AxiosPromise<ApiResponseOfPlatformGroupResponse> {
            return localVarFp.create(platformGroupBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all platform groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options?: any): AxiosPromise<ApiResponseOfPlatformGroupResponseArray> {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get platform group by ID
         * @param {string} platformGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(platformGroupId: string, options?: any): AxiosPromise<ApiResponseOfPlatformGroupResponse> {
            return localVarFp.getById(platformGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete platform group by ID
         * @param {string} platformGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(platformGroupId: string, options?: any): AxiosPromise<void> {
            return localVarFp.remove(platformGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update platform group by ID
         * @param {string} platformGroupId 
         * @param {PlatformGroupBody} platformGroupBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(platformGroupId: string, platformGroupBody: PlatformGroupBody, options?: any): AxiosPromise<ApiResponseOfPlatformGroupResponse> {
            return localVarFp.update(platformGroupId, platformGroupBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlatformGroupsApi - interface
 * @export
 * @interface PlatformGroupsApi
 */
export interface PlatformGroupsApiInterface {
    /**
     * 
     * @summary Create a new platform group
     * @param {PlatformGroupBody} platformGroupBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformGroupsApiInterface
     */
    create(platformGroupBody: PlatformGroupBody, options?: any): AxiosPromise<ApiResponseOfPlatformGroupResponse>;

    /**
     * 
     * @summary List all platform groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformGroupsApiInterface
     */
    getAll(options?: any): AxiosPromise<ApiResponseOfPlatformGroupResponseArray>;

    /**
     * 
     * @summary Get platform group by ID
     * @param {string} platformGroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformGroupsApiInterface
     */
    getById(platformGroupId: string, options?: any): AxiosPromise<ApiResponseOfPlatformGroupResponse>;

    /**
     * 
     * @summary Delete platform group by ID
     * @param {string} platformGroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformGroupsApiInterface
     */
    remove(platformGroupId: string, options?: any): AxiosPromise<void>;

    /**
     * 
     * @summary Update platform group by ID
     * @param {string} platformGroupId 
     * @param {PlatformGroupBody} platformGroupBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformGroupsApiInterface
     */
    update(platformGroupId: string, platformGroupBody: PlatformGroupBody, options?: any): AxiosPromise<ApiResponseOfPlatformGroupResponse>;

}

/**
 * PlatformGroupsApi - object-oriented interface
 * @export
 * @class PlatformGroupsApi
 * @extends {BaseAPI}
 */
export class PlatformGroupsApi extends BaseAPI implements PlatformGroupsApiInterface {
    /**
     * 
     * @summary Create a new platform group
     * @param {PlatformGroupBody} platformGroupBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformGroupsApi
     */
    public create(platformGroupBody: PlatformGroupBody, options?: any) {
        return PlatformGroupsApiFp(this.configuration).create(platformGroupBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all platform groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformGroupsApi
     */
    public getAll(options?: any) {
        return PlatformGroupsApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get platform group by ID
     * @param {string} platformGroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformGroupsApi
     */
    public getById(platformGroupId: string, options?: any) {
        return PlatformGroupsApiFp(this.configuration).getById(platformGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete platform group by ID
     * @param {string} platformGroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformGroupsApi
     */
    public remove(platformGroupId: string, options?: any) {
        return PlatformGroupsApiFp(this.configuration).remove(platformGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update platform group by ID
     * @param {string} platformGroupId 
     * @param {PlatformGroupBody} platformGroupBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformGroupsApi
     */
    public update(platformGroupId: string, platformGroupBody: PlatformGroupBody, options?: any) {
        return PlatformGroupsApiFp(this.configuration).update(platformGroupId, platformGroupBody, options).then((request) => request(this.axios, this.basePath));
    }
}
